import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { filter, take } from 'rxjs';
import { map } from 'rxjs/operators';
import { RequestStatus } from 'ngxs-requests-plugin';
import { YearsService } from '../services/years.service';


export const GetYearListResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const yearsService = inject(YearsService);
  if (!!yearsService.getYearListSnapshot()?.length) {
    return true;
  }
  yearsService.getYearList();
  return yearsService.getYearListRequestState$.pipe(
    filter(({loaded, status}) => loaded && status === RequestStatus.Success),
    take(1),
    map(res => {
      return res.data;
    })
  );
}
